import styled, { css } from "styled-components/macro";

import { colors, space, spinnerKeyframes } from "shared/styles/constants";
import { ITheme } from "shared/types";

export interface SpinnerProps {
  size?: "s" | "l";
  theme?: ITheme;
  text?: string;
}

const getSpinnerColor = (theme: ITheme): colors => {
  switch (theme) {
    case ITheme.tertiary:
      return colors.black;
    default:
      return colors.white;
  }
};

const getSpinnerSize = (size?: "s" | "l"): string => {
  switch (size) {
    case "s":
      return "8px";
    default:
      return "16px";
  }
};

const spinnerAnimationRule = css`
  animation: ${spinnerKeyframes} 1.4s infinite ease-in-out both;
`;

export const Spinner = styled.div<SpinnerProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  > * {
    width: ${({ size }) => getSpinnerSize(size)};
    height: ${({ size }) => getSpinnerSize(size)};
    background-color: ${({ theme }) => getSpinnerColor(theme)};

    border-radius: 100%;
    display: inline-block;

    ${spinnerAnimationRule};
  }

  > * + * {
    margin-left: ${space.xxs};
    margin-left: ${({ size }) => (size === "l" ? space.xxs : "2px")};
  }

  ${({ size }) =>
    size === "l" &&
    css`
      grid-column: 1/3;
      margin: ${space.l};
    `};
`;

export const Bounce1 = styled.div`
  animation-delay: -0.32s !important;
`;

export const Bounce2 = styled.div`
  animation-delay: -0.16s !important;
`;

export const Bounce3 = styled.div``;
